module.exports = __webpack_public_path__ + "9ac064443cc031648ca8836ba02b7b02.png";